<script setup>
import { computed, defineProps, provide } from 'vue'

import { fieldNameKey } from './symbols'

const props = defineProps(['fieldName'])

provide(fieldNameKey, computed(() => props.fieldName))
</script>

<template>
  <slot :fieldName="fieldName"></slot>
</template>
